function getCart() {
  return fetch('/cart.js').then(r => r.json());
}

async function setQuantity() {
  const selectQuantity = document.getElementsByClassName('quantity__input')[0];
  if (!selectQuantity) return;

  const el = document.getElementById('minimumStock');
  if (!el) return;

  const minimumRequired = Number(el.dataset.min);
  const select = document.getElementsByClassName('select__select')[0];
  if (!select) return;

  const selectedOption = select.options[select.selectedIndex];
  const variantId = selectedOption.dataset.variantId;
  const availableQuantity = Number(selectedOption.dataset.availableQuantity);

  const cart = await getCart();
  const itemInCart = cart.items.find(item => item.id == variantId);
  const quantityInCart = itemInCart ? itemInCart.quantity : 0;
  selectQuantity.max = availableQuantity - quantityInCart - minimumRequired;
}

function watchQuantity() {
  document.querySelectorAll('.select__select').forEach(select => {
    setHowAvailable(select);
    select.addEventListener('change', () => {
      setQuantity();
      setHowAvailable(select);
      setStoreAvailability(select);
    });
  });
}

function setStoreAvailability(select) {
  if (!document.querySelector('[data-section-id="stock-locator"]')) return;
  const selectedOption = select.options[select.selectedIndex];
  fetchAndLogStockLocatorHtml(selectedOption.dataset.variantId).catch(console.error);
}

function setHowAvailable(select) {
  const selectedOption = select.options[select.selectedIndex];
  const totalAvailable = Number(selectedOption.dataset.availableQuantity);

  const productLowStockEl = document.getElementById('productLowStockQuantity');
  if (!productLowStockEl) return;

  const productLowStockQuantity = Number(productLowStockEl.dataset.productLowStockQuantity);

  if (totalAvailable <= productLowStockQuantity) {
    const howAvailableDiv = document.querySelector('.how-available');
    if (howAvailableDiv && totalAvailable > 0) {
      howAvailableDiv.classList.remove('d-none');
      const howAvailableNum = document.querySelector('.how-available-number');
      if (howAvailableNum) howAvailableNum.textContent = totalAvailable;
    }
    return totalAvailable;
  } else {
    const howAvailableDiv = document.querySelector('.how-available');
    if (howAvailableDiv) howAvailableDiv.classList.add('d-none');
  }
}

// Fonction stub conservée car appelée depuis product-form.js après ajout au panier
function initializeVariantCheck() {}

async function fetchAndLogStockLocatorHtml(
  variantId,
  { productUrlSelector = '[data-product-url]', sectionId = 'stock-locator', timeoutMs = 10000, part = 'outer' } = {}
) {
  const urlHost = document.querySelector(productUrlSelector);
  if (!urlHost) throw new Error(`Aucun élément trouvé pour ${productUrlSelector}`);

  const base = urlHost.dataset.productUrl;
  if (!base) throw new Error('data-product-url manquant');

  const url = new URL(base, window.location.origin);
  url.searchParams.set('variant', variantId);

  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
      signal: controller.signal,
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const selector = `[data-section-id="${sectionId}"]`;
    const node = doc.querySelector(selector);
    if (!node) throw new Error(`Section introuvable : ${selector}`);

    const snippet = part === 'inner' ? node.innerHTML : node.outerHTML;
    const current = document.querySelector(selector);

    if (!current) {
      console.warn(`Conteneur local introuvable : ${selector}`);
    } else if (part === 'inner') {
      current.innerHTML = node.innerHTML;
      current.dispatchEvent(new CustomEvent('stock-locator:updated', { bubbles: true, detail: { variantId, sectionId } }));
    } else {
      current.outerHTML = node.outerHTML;
      document.dispatchEvent(new CustomEvent('stock-locator:updated', { bubbles: true, detail: { variantId, sectionId } }));
    }

    return snippet;
  } finally {
    clearTimeout(t);
  }
}
